import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getWebClient } from '../helpers/Helpers.js';
import Spinner from './components/Spinner';
import Navbutton from './components/Navbutton.js';
import PartnerDateTime from './components/PartnerDateTime';
import PromptConfirmAppointment from './components/PromptConfirmAppointment';
import PromptConfirmAppointmentQueue from './components/PromptConfirmAppointmentQueue';
import PromptMailSent from './components/PromptMailSent';
import PromptError from './components/PromptError';
import { MainSettingsContext } from '../App.js';

export default function PartnerAgenda() {

    const { locationAndDates } = useContext(MainSettingsContext);

    const { partnerid } = useParams();
    const [viewMode, setViewMode] = useState('waiting');
    const [profile, setprofile] = useState({ company: '' });
    const [agenda, setagenda] = useState([]);
    const [days, setDays] = useState([{ label: '1ST JANUARY', id: '7B941341-9C20-4A14-B1CA-8A50780D67FC', enabled: true }, { label: '2ND JANUARY', id: '6952AE3A-B7A6-4998-9AD5-4B3F8D825A61', enabled: true }, { label: '3RD JANUARY', id: '325A3625-98F8-4CAB-AF6F-94B378E3BAD6', enabled: true }]);
    const [day, setDay] = useState(0);
    const [dateTimeToBookId, setDateTimeToBookId] = useState([]);
    const [dateTimeToBookQueueId, setDateTimeToBookQueueId] = useState([]);
    const navigate = useNavigate();
    const client = getWebClient();

    useEffect(() => {

        client.get(`/api/getpartnerenableddates/${partnerid}`)
            .then(function (response) {

                setDays(response.data.filter(obj => {
                    return obj.enabled === true
                }));

                client.get(`/api/getpartnerprofile/${partnerid}`)
                    .then(function (response) {
                        setprofile(response.data);
                        fetchData(days[0].id);
                    })
                    .catch(function (error) {
                        console.log(error);
                        setViewMode('error');
                    });

            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }, []);


    const fetchData = async (dayId) => {

        client.get(`/api/getpartneragenda/${partnerid}/${dayId}`)
            .then(function (response) {
                setagenda(response.data);
                setViewMode('');
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    };   

    function handleAppointmentCreateClick(dateTimeId) {
        setDateTimeToBookId(dateTimeId);
        setViewMode('appointmentcreate');
    }

    function doAppointmentCreate() {

        setViewMode('waiting');

        client.get(`/api/sendappointmentrequest/${partnerid}/${dateTimeToBookId}`)
            .then(function (response) {
                setViewMode('mailsent');
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }

    function handleAppointmentQueueCreateClick(dateTimeId) {
        setDateTimeToBookQueueId(dateTimeId);
        setViewMode('appointmentqueuecreate');
    }

    function doAppointmentQueueCreate() {

        setViewMode('waiting');

        client.get(`/api/sendappointmentrequestqueue/${partnerid}/${dateTimeToBookQueueId}`)
            .then(function (response) {
                setViewMode('mailsent');
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }

    function handlePreviousDayClick(appointmentid) {
        if (day > 0) {
            let newday = day - 1;
            setDay(newday);
            fetchData(days[newday].id);
        }
    }

    function handleNextDayClick(appointmentid) {
        if (day < days.length - 1) {
            let newday = day + 1;
            setDay(newday);
            fetchData(days[newday].id);
        }
    }

    const partnerDateTimes = agenda.map((dateTime, index) => {
        return (<PartnerDateTime dateTime={dateTime} handleAppointmentCreateClick={handleAppointmentCreateClick} handleAppointmentQueueCreateClick={handleAppointmentQueueCreateClick} />)
    });

    return (
        <>

            <section className="buyer-sec ca-sec">
                <header className="header">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="/assets/images/logo.svg" alt="" />
                        </div>
                        <div className="col-md-6">
                            <h2>Workshop Agenda</h2>
                            <p>{locationAndDates}</p>
                        </div>
                    </div>
                </header>
                <div className="container  ca-container">
                    <h1 className="main-heading">Company Agenda</h1>
                    <p>Here is the agenda of ‘{profile.company}’, ask for an appointment!</p>
                    <div className="row">
                        <h4>Description</h4>
                        <ul>
                            <li className=""> <img src="/assets/images/icon.svg" alt="" /> <span> The appointment is available </span></li>
                            <li className=""> <img src="/assets/images/icon2.svg" alt="" /> <span> The appointment is already booked, but you can put yourself in queue </span></li>
                            <li className=""> <img src="/assets/images/icon3.svg" alt="" /> <span> If the appointment is already booked click here to put yourself on queue </span></li>
                            <li className=""> <img src="/assets/images/icon4.svg" alt="" /> <span> The appointment is free but you are already busy at this time  </span></li>
                            <li className=""> <img src="/assets/images/icon5.svg" alt="" /> <span> The queue is free but you are already busy at this time</span></li>
                            <li className=""> <img src="/assets/images/icon6.svg" alt="" /> <span> The appointment or the queue are busy fot both; chose another slot </span></li>
                        </ul>
                        <div className="col-md-12 text-center">
                            <div className="btn btn-primary main-btn button-fullwidth">
                                <img src="/assets/images/iconLeft.svg" id="leftArrow" alt="" onClick={handlePreviousDayClick} />
                                <button className="btn btn-primary" id="appointmentButton">{days[day].label} appointments</button>
                                <img src="/assets/images/iconRight.svg" id="rightArrow" alt="" onClick={handleNextDayClick} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <table className="table search-table table-striped ca-table">
                                <thead>
                                    <tr>
                                        <th className="ps-2">Time</th>
                                        <th className="ps-2">Available</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {partnerDateTimes}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-12 text-center">
                            <div className="back-btn">
                                <button className="btn btn-secondary" onClick={() => navigate(-1)}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer">
                    <ul>
                        <li>&copy; {new Date().getFullYear()} - PromAx Communication SA - <a target="_blank" rel="noreferrer" href='http://www.sihe.ch'>www.sihe.ch</a><br></br>Tel. 0041/91/6118070 - <a href="mailto:segreteria@sihe.ch">segreteria@sihe.ch </a></li>
                    </ul>
                </footer>
            </section>

            <Navbutton></Navbutton>

            <Spinner show={viewMode === 'waiting'}></Spinner>
            <PromptConfirmAppointment show={viewMode === 'appointmentcreate'} setViewMode={setViewMode} doAppointmentCreate={doAppointmentCreate}></PromptConfirmAppointment>
            <PromptConfirmAppointmentQueue show={viewMode === 'appointmentqueuecreate'} setViewMode={setViewMode} doAppointmentQueueCreate={doAppointmentQueueCreate}></PromptConfirmAppointmentQueue>
            <PromptMailSent show={viewMode === 'mailsent'} setViewMode={setViewMode}></PromptMailSent>
            <PromptError show={viewMode === 'error'} setViewMode={setViewMode}></PromptError>

        </>
    );

}